import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/utils/apiRequest";
import { GET_SHIPMENT_INVOICE_PHOTO } from "@/constants/Query";
import { IShipmentInvoiceResponse } from "@/types/apiResponse.types";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";

export const useGetShipmentInvoiceRequest = (shipmentId: number | null) => {
  const theme = useTheme();

  return useQuery<{
    data: {
      data: IShipmentInvoiceResponse;
    };
  }>({
    queryKey: [GET_SHIPMENT_INVOICE_PHOTO, shipmentId],
    queryFn: () =>
      apiRequest(GET_SHIPMENT_INVOICE_PHOTO, "get", {
        shipmentId,
      }),
    enabled: !!shipmentId && theme === Theme.GEORGIA,
  });
};
